module.exports = __webpack_public_path__ + "img/AN.d1342d77.svg";